import React, { useState } from 'react'
import { Button } from 'syngenta-react-components'
import { useForm, Controller } from 'react-hook-form'
import { postTrainingVideo, patchTrainingVideo } from '../../services/apiHelper'
import Select from '../../dpe-usco/components/Select/Select'
import TableStatus from '../subComponents/TableStatus/TableStatus'

const UploadTrainingVideoForm = ( { addButtonYears, handleClose, isVideoEdit, editYear, videoUrl }) => {
  const [modalStatus, setModalStatus] = useState('')
  const [trainingError, setTrainingError] = useState(false)

  const { register, control, reset, handleSubmit, errors, setValue } = useForm({
    defaultValues: {
      sales_years: isVideoEdit ? editYear : '',
      video_path: isVideoEdit ? videoUrl : ''
    }
  })

  const onSubmit = formValues => {
    if (formValues.video_path?.endsWith('.mp4')) {
      setModalStatus('LOADING')
      const paramData = {
        training_steps: [
          {
            type: 'video',
            training: formValues.video_path
          }
        ],
        training_id: 'Enogen-Stewardship-'+formValues.sales_years
      }
      setTrainingError(false)
      if(isVideoEdit) {
        patchTrainingVideo(paramData, 'Enogen-Stewardship-'+formValues.sales_years).then(response => {
          if (response?.data?.training_id) {
            setModalStatus('SUCCESS')
          } else {
            setModalStatus('FAILED')
          }
        })
      } else {
        postTrainingVideo(paramData).then(response => {
          if (response?.data?.training_id) {
            setModalStatus('SUCCESS')
          } else {
            setModalStatus('FAILED')
          }
        })
      }
    } else {
      setTrainingError(true)
    }
  }

  const handleSelectYear = option => {
    setValue('sales_years', option)
  }

  const generateSalesYearRadioButtons = () => {
    return(
      <div className='w45% mb20'>
        <label className='fz16'>Training Year*</label>
        <Controller
          as={<Select defaultId={isVideoEdit ? editYear : null}/>}
          placeholder='Select year'
          options={addButtonYears}
          value={2004}
          control={control}
          handleSelection={handleSelectYear}
          name='sales_years'
          id='sales_years'
          rules={{ required: true }}
          disabled={isVideoEdit}
        />
        <div className='c-red tal fz12'>
          {errors.sales_years && errors.sales_years.type === 'required' && 'Please select year'}
        </div>
      </div>
    )
  }

  let content = (
    <div className='pl16 pr16'>
      {generateSalesYearRadioButtons()}
      <div className='mb30'>
        <label className='fz16' htmlFor='video_path'>Video URL*</label>
        <div className='mb10'>
          <input
            className='bd2-s-input mt4 fz15'
            type="text"
            id='video_path'
            name="video_path"
            ref={register({ required: true })}
          />
          <div className='c-red tal fz12'>{trainingError}
            {errors.video_path && errors.video_path.type === 'required' ? 'Please provide MP4 video URL' : trainingError ? 'Please provide valid MP4 video URL': null}
          </div>
        </div>
      </div>
    </div>
  )

  const handleCloseModal = arg => {
    handleClose(arg)
    reset()
  }

  let bottomButtons = (
    <>
      <Button type='outline' text='Cancel' customClassName='mr8 miw75 pl1 pr1' clickHandler={handleCloseModal} />
      <Button type='success' text={'Save'} clickHandler={handleSubmit(onSubmit)} customClassName='miw70' />
    </>
  )

  const closeModelHandler = arg => {
    window.location.reload()
  }

  switch(modalStatus){
    case 'LOADING':
      content = (
        <>
          <p className='w100% p0'>Upload training video in progress. Please wait.</p>
          <TableStatus status='LOADING'/>
        </>
      )
      bottomButtons = (
        <Button disabled type='success' text='Close' clickHandler={closeModelHandler} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'SUCCESS':
      content = (
        <p className='w100% p0'>Successfully uploaded training video.</p>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={() => closeModelHandler('SUCCESS')} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'FAILED':
      content = (
        <p className='w100% p0'>Something went wrong. Please contact your admin.</p>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={closeModelHandler} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    default:
      break
  }

  return(
    <form className='w100% tal' onSubmit={handleSubmit(onSubmit)}>
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb mb16'>
          <div className='df ml15 mt15 mb15'>
            <div className='fw600 ml10'>
              { isVideoEdit? 'Edit' : 'Add' } Training Video
            </div>
          </div>
        </div>
        {content}
        <div className='bt1-s-lightgray df aic jcfe mt16' data-testid='newCompanyButtons'>
          <div className='mt10 mb8 mr8'>
            {bottomButtons}
          </div>
        </div>
      </div>
    </form>
  )
}

export default UploadTrainingVideoForm